import mixpanel from "mixpanel-browser";

mixpanel.init("993862693730b7e20a9220fcc344f9b1");

const envCheck = process.env.NODE_ENV === "production";

let actions = {
  identify: (id) => {
    if (envCheck) mixpanel.identify(id);
  },
  alias: (id) => {
    if (envCheck) mixpanel.alias(id);
  },
  track: (name, props) => {
    if (envCheck) mixpanel.track(name, props);
  },
  people: {
    set: (props) => {
      if (envCheck) mixpanel.people.set(props);
    },
  },
};

export const Mixpanel = actions;
